<template>
  <div>
    <el-row>
      <el-col :xl="{ span: 22, offset: 1 }" :lg="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }"
        :sm="{ span: 24, offset: 0 }" :xs="{ span: 22, offset: 1 }" class="selector">
        <div class="link-wrapper">
          <!-- one of these will be hidden at all times -->
          <product-category-link v-for="(productCategory) in getFilteredCategories"
            v-bind:key="productCategory.id + 'mobile'" :product-category="productCategory"
            :selected="productCategory.slug === $route.params.category" :mobile="true">
          </product-category-link>
          <product-category-link v-for="(productCategory) in getFilteredCategories" v-bind:key="productCategory.id"
            :product-category="productCategory" :selected="productCategory.slug === $route.params.category"
            :mobile="false">
          </product-category-link>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import products from '.';
import { mapGetters } from 'vuex';
import ProductCategoryLink from '@/components/products/ProductCategoryLink.vue'

export default {
  name: 'ProductCategorySelector',
  computed: {
    ...mapGetters(products.store.namespace, [
      'getFilteredCategories'
    ]),
  },
  components: {
    ProductCategoryLink,
  }
}

  ////////


</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';
@import '@/assets/base/_variables.scss';

.selector {
  background-color: $--color-white;
  box-shadow: 0px 6px 40px rgba(0, 0, 0, 0.15);
  margin-bottom: 70px;
}

.link-wrapper {
  display: flex;
  flex-wrap: no-wrap;
  padding: 30px;
  gap: 2px;

  @include res(sm-only, $--breakpoints-spec) {
    padding: 10px;
  }

  @include res(xs-only, $--breakpoints-spec) {
    padding: 10px;
    flex-direction: column;
  }

}
</style>
